module.exports = __webpack_public_path__ + "img/jar-bill.801e24a.png";